import React, { useState } from 'react'
import { Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'
import QtyInput from '../../Shared/QtyInput'
import QtyInputPlusMinus from '../../Shared/QtyInputPlusMinus'
// import ChangeProductsModal from './ChangeProductsModal'
// import { GiCardExchange } from 'react-icons/gi'

export default ({ touched, errors, setFieldValue, values, handleBlur }) => {
  const [changeProductsModalShow, setChangeProductsModalShow] = useState(false)
  const [productItem, setProductItem] = useState({})

  // const hamdleChangeProductClick = (item) => {
  //   console.log(item);
  //   console.log(values.previousInputs);

  //   let remainingQuantity = 0

  //   if (values.previousInputs) {

  //     let previousInputs = values.previousInputs.filter(el => el.product.id === item.product.id)

  //     if (previousInputs) {
  //       let usedQuantity = 0;

  //       previousInputs.forEach(p => {
  //         usedQuantity += p.quantity
  //       });
  //       console.log(usedQuantity);

  //     }

  //   }

  //   setProductItem(item)
  //   setChangeProductsModalShow(true)
  // }

  return (
    <>
      <div className="row display-flex">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <fieldset className="fieldset">
            <legend>
              مواد اولیه
              {/* <a className="btn btn-sm btn-danger" style={{ marginRight: 15 }} onClick={() => setChangeProductsModalShow(true)}>تعویض مواد اولیه</a> */}
            </legend>
            <table
              className="table validator-table"
              style={{ marginBottom: 5 }}>
              <thead>
                <tr>
                  <th className="text-center">ردیف</th>
                  {/* <th className="text-center">تعویض</th> */}
                  <th className="text-center">دسته بندی</th>
                  <th className="text-center">برند</th>
                  <th className="text-center">نام کالا</th>
                  <th className="text-center">مقدار اولیه</th>
                  {values.unitTaskStatus === 2 ? (
                    <th className="text-center">
                      ( + ) مصرف اضافی | برگشت به انبار ( - )
                    </th>
                  ) : (
                    ''
                  )}
                  {values.unitTaskStatus === 2 ? (
                    <th className="text-center">ضایعات</th>
                  ) : (
                    ''
                  )}
                  {/* <th className="text-center">واحد شمارش</th> */}
                </tr>
              </thead>
              <tbody>
                {values.items &&
                  values.items.map((item, index) => (
                    <tr key={'p-' + index}>
                      <td>{index + 1}</td>
                      {/* <td>
                      <a onClick={() => hamdleChangeProductClick(item)}>
                        <GiCardExchange size="24px" color="#F44336" />
                      </a>
                    </td> */}
                      <td>
                        {values.items[index].product &&
                          values.items[index].product.category.name}
                      </td>
                      <td>
                        {values.items[index].product &&
                          values.items[index].product.brand.name}
                      </td>
                      <td>
                        {values.items[index].product &&
                          values.items[index].product.name}
                      </td>
                      <td>
                        {values.items[index].product && (
                          <MeasurementTypeDoubleBox
                            product={values.items[index].product}
                            value={values.items[index].firstQuantity}
                            onlySub={
                              values.items[index].product.subMeasurementType !==
                              null
                                ? true
                                : false
                            }
                          />
                        )}
                      </td>
                      {values.unitTaskStatus === 2 ? (
                        <td>
                          <QtyInputPlusMinus
                            defaultValue={values.items[index].subExtraQuantity}
                            measurementType={
                              values.items[index].product &&
                              values.items[index].product.measurementType
                            }
                            subMeasurementType={
                              values.items[index].product &&
                              values.items[index].product.subMeasurementType
                            }
                            conversionUnit={
                              values.items[index].product &&
                              values.items[index].product.conversionUnit
                            }
                            onChange={(val, subVal) => {
                              // if (subVal) {

                              // if (val <= values.items[index].unitProductQuantity) {
                              setFieldValue(
                                `items[${index}][subExtraQuantity]`,
                                subVal
                              )
                              // } else {
                              //   setFieldValue(`items[${index}][subExtraQuantity]`, undefined)
                              //   setFieldValue(`items[${index}][extraQuantity]`, undefined)
                              // }

                              // } else {
                              //   setFieldValue(`items[${index}][subExtraQuantity]`, undefined)
                              // }

                              setFieldValue(
                                `items[${index}][extraQuantity]`,
                                val
                              )
                            }}
                          />
                        </td>
                      ) : (
                        ''
                      )}
                      {values.unitTaskStatus === 2 ? (
                        <>
                          {/* <td>
                      <DecimalInput type='tel'
                        value={values.items[index].waste}
                        maxLength={values.items[index].waste}
                        onChange={e => {
                          setFieldValue(`items[${index}][waste]`, e.target.value)
                        }}
                        className="text-input"
                      />
                      <ErrorMessage component={ErrorPopUp} name={`items[${index}].waste`} />
                    </td> */}
                          <td>
                            <div>
                              <QtyInput
                                disabled={
                                  values.items[index].product &&
                                  values.items[index].product.conversionUnit
                                }
                                className="text-input"
                                measurementType={
                                  values.items[index].product &&
                                  values.items[index].product.measurementType
                                }
                                subMeasurementType={
                                  values.items[index].product &&
                                  values.items[index].product.subMeasurementType
                                }
                                conversionUnit={
                                  values.items[index].product &&
                                  values.items[index].product.conversionUnit
                                }
                                onChange={(val, subVal) => {
                                  // if (subVal !== undefined) {

                                  //   if (val <= values.items[index].unitProductQuantity) {
                                  setFieldValue(
                                    `items[${index}][subWaste]`,
                                    subVal
                                  )
                                  //   } else {
                                  //     setFieldValue(`items[${index}][subWaste]`, undefined)
                                  //     setFieldValue(`items[${index}][waste]`, undefined)
                                  //   }

                                  // } else {
                                  //   setFieldValue(`items[${index}][subWaste]`, undefined)
                                  // }

                                  setFieldValue(`items[${index}][waste]`, val)
                                }}
                                // max={values.items[index].unitProductQuantity}
                                value={values.items[index].waste}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name={`items[${index}].waste`}
                                style={{ margin: '0 auto' }}
                              />
                            </div>
                          </td>
                          {/* <td>
                         {values.items[index].product && values.items[index].product.conversionUnit ?
                          <QtyInput
                            measurementType={values.items[index].product && values.items[index].product.subMeasurementType != undefined && measurementTypes.filter(el => el.value === values.items[index].product.subMeasurementType)[0] && measurementTypes.filter(el => el.value === values.items[index].product.subMeasurementType)[0].label}
                            className="text-input"
                            onChange={val => {

                              if (val) {
                                let waste = ConvertQuantity(val, values.items[index].product.conversionUnit, 3, 1);
                                if (waste <= values.items[index].unitProductQuantity) {
                                  setFieldValue(`items[${index}][waste]`, waste)
                                } else {
                                  setFieldValue(`items[${index}][waste]`, undefined)
                                  setFieldValue(`items[${index}][subWaste]`, undefined)
                                }

                              } else {
                                setFieldValue(`items[${index}][waste]`, undefined)
                              }
                              setFieldValue(`items[${index}][subWaste]`, val)
                            }}
                            max={(Number((values.items[index].unitProductQuantity / values.items[index].product.conversionUnit).toFixed(3)))}
                            value={values.items[index].subWaste}
                          />
                          : ''}
                        {(values.items[index].product && values.items[index].product.conversionUnit) &&
                          <ErrorMessage component={ErrorPopUp} name={`items[${index}].waste`} />
                        } 
                      </td>*/}
                        </>
                      ) : (
                        ''
                      )}
                      {/* <td>
                    {values.items[index].product ? measurementTypes.filter(el => el.value === values.items[index].product.measurementType)[0].label : ''}
                  </td> */}
                    </tr>
                  ))}
              </tbody>
            </table>
          </fieldset>
        </div>
      </div>

      {/* <ChangeProductsModal taskId={values.taskId} item={productItem} show={changeProductsModalShow} onClose={() => setChangeProductsModalShow(false)} /> */}
    </>
  )
}
